import { ROUTES } from '../constants/routes';

export function isFreeCoursesCategory(category) {
  return Number(category?.id) === 0;
}

export function hasSubcategories(category) {
  return Array.isArray(category?.subcategories) && category.subcategories.length > 0;
}

export function getCategoryIconType(name) {
  const value = String(name || '').toLowerCase();

  if (value.includes('physics')) return 'physics';
  if (value.includes('chemistry')) return 'chemistry';
  if (value.includes('math')) return 'math';
  if (value.includes('biology') || value.includes('bio')) return 'biology';

  return 'physics';
}

export function getFreeCoursesPath() {
  return ROUTES.FREE_COURSES;
}

export function getSubcategoryCoursesPath(categoryId, subcategoryId) {
  const params = new URLSearchParams({
    category_id: String(categoryId),
    subcategory_id: String(subcategoryId),
  });

  return `${ROUTES.COURSES_BROWSE}?${params.toString()}`;
}

export function getCategoryNavigationTarget(category) {
  if (!category) return null;

  if (isFreeCoursesCategory(category)) {
    return { path: getFreeCoursesPath(), state: {} };
  }

  const subcategories = category.subcategories || [];
  if (subcategories.length >= 1) {
    const subcategory = subcategories[0];
    return {
      path: getSubcategoryCoursesPath(category.id, subcategory.id),
      state: {
        categoryName: category.name,
        subcategoryName: subcategory.name,
      },
    };
  }

  const params = new URLSearchParams({ category_id: String(category.id) });
  return {
    path: `${ROUTES.COURSES_BROWSE}?${params.toString()}`,
    state: { categoryName: category.name },
  };
}
